module.exports = __webpack_public_path__ + "static/media/celular-mais-novo.e308d749.png";